import htmlComponent from 'htmlcomponent'
import {isMobile} from '@/utils/features';

export default function (dom, opts) {
    let options = {
        classes: {
            showNav: 'show--nav',
            showSubNav: 'show--subnav',
            navOverflow: 'nav-overflow'
        },
        selectors: {
            navToggle: '[data-nav-toggle]',
            navOpen: '[data-nav-open]',
            navClose: '[data-nav-close]',

            navWrapper: '.nav-wrapper',
            navItems: '[data-subnav-open]',
            navBackItems: '[data-subnav-close]',
        },

        ...opts
    };

    const html = document.documentElement;
    const body = document.body;
    const navWrapper = dom.querySelector(options.selectors.navWrapper);
    const navItems = Array.from(dom.querySelectorAll(options.selectors.navItems));
    const navBackItems = Array.from(dom.querySelectorAll(options.selectors.navBackItems));

    init()

    function init() {
        Array.from(document.querySelectorAll(options.selectors.navToggle)).forEach(el => {
            el.addEventListener('click', onToggle);
        });
        Array.from(document.querySelectorAll(options.selectors.navOpen)).forEach(el => {
            el.addEventListener('click', onOpen);
        });
        Array.from(document.querySelectorAll(options.selectors.navClose)).forEach(el => {
            el.addEventListener('click', onClose);
        });
        navItems.forEach(el => {
            el.addEventListener('click', onSubnavOpen);
        });
        navBackItems.forEach(el => {
            el.addEventListener('click', onSubnavClose);
        });
        body.addEventListener('click', onOuterClick);
    }

    function onToggle() {
        if (html.classList.contains(options.classes.showNav)) {
            onClose();
        } else {
            onOpen();
        }
    }

    function onOpen() {
        htmlComponent.send('navigation:open');
        // reset subnav states and set active trail
        navItems.forEach(item => {
            item.closest('li').classList.remove(options.classes.showSubNav);
            item.closest('ul').classList.remove(options.classes.showSubNav);

        });

//        opens navi on current active page (mobile)
        /*		navItems.filter(item => item.closest('li').classList.contains('trail')).forEach(item => {
                    item.closest('li').classList.add(options.classes.showSubNav);
                    item.closest('ul').classList.add(options.classes.showSubNav);
                });*/

        html.classList.add(options.classes.showNav);
    }

    function onClose() {
        htmlComponent.send('navigation:close');
        html.classList.remove(options.classes.showNav);
        navWrapper.classList.remove(options.classes.showSubNav);

        navItems.forEach(item => {
            item.classList.remove(options.classes.navOverflow);
            item.closest('li').classList.remove(options.classes.showSubNav);
            item.closest('ul').classList.remove(options.classes.showSubNav);
        });
    }

    function onOuterClick(e) {
        if (!isMobile() && !navWrapper.contains(e.target)) {
            onClose()
        }
    }


    function onSubnavOpen(e) {
        e.preventDefault();
        const navItem = e.target;
        const li = navItem.closest('li');
        const ahref = navItem.closest('a');
        const ul = navItem.closest('ul');
        const div = navItem.closest('div');
        const subNav = navItem.nextElementSibling;

        // prevent jumping to top of screen on mobile
        if (li.dataset.hci === 'app/collapsible' && window.innerWidth < 1024) {
            return
        }

        Array.from(navItem.closest('ul').children).forEach(item => {
            let alink = item.children.item('a');
            item.classList.remove(options.classes.showSubNav);
            alink.classList.remove(options.classes.navOverflow);
        });

        li.classList.add(options.classes.showSubNav);
        ahref.classList.add(options.classes.navOverflow);
        ul.classList.add(options.classes.showSubNav);
        div.classList.add(options.classes.showSubNav);
        div.scrollTop = 0;
        div.scrollLeft = 0;
        subNav.scrollTop = 0;
        subNav.scrollLeft = 0;

        html.classList.add(options.classes.showNav);
    }

    function onSubnavClose(e) {
        e.preventDefault();
        const navItem = e.target;
        const li = navItem.closest('li');
        const ul = navItem.closest('ul');
        const div = ul.closest('div');

        li.classList.remove(options.classes.showSubNav);
        ul.classList.remove(options.classes.showSubNav);
        div.classList.remove(options.classes.showSubNav);


        // if there are no more levels to go back and it's not mobile, close the nav
        if (!isMobile() && navItem.closest('ul') == navItem.closest('ul').closest('ul')) {
            onClose();
        }
    }
}
